export default __webpack_public_path__ + "static/media/lp-sec02_ttl.cd945805.png";